import Vue from 'vue'
import request from '@/helpers/request'
import snack from '@/helpers/snack'

export default {
  GET_GOOD_TYPES: ({ commit, state }, payload) => {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.goodTypes.all}`,
      {
        params: payload?.params,
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const data = response.data.data
        commit('setGoodTypes', data.items)
      } else {
        // TODO: Show error dialog
      }
    })
  },
  CREATE_GOOD_TYPE: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'POST',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodTypes.all}`,
        {
          title: payload.title,
        },
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          commit('addGoodType', response.data.data)

          snack.add(Vue.config.localization.ru.savedMessage, 'primary')
        } else {
          snack.add(Vue.config.localization.ru.errorSavingMessage)
        }
      })

      commit('setLoad', false)
      resolve()
    })
  },
  UPDATE_GOOD_TYPE: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'PUT',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodTypes.one.replace('$1', payload.id)}`,
        {
          title: payload.title,
        },
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          commit('changeGoodType', response.data.data)

          snack.add(Vue.config.localization.ru.savedMessage, 'primary')
        } else {
          snack.add(Vue.config.localization.ru.errorSavingMessage)
        }
      })

      commit('setLoad', false)
      resolve()
    })
  },
  DELETE_GOOD_TYPE: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'DELETE',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodTypes.one.replace('$1', payload.id)}`,
        {},
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          commit('removeGoodType', payload.id)

          snack.add(Vue.config.localization.ru.successRemove, 'primary')
        } else {
          snack.add(Vue.config.localization.ru.errors.removing)
        }
      })

      commit('setLoad', false)
      resolve()
    })
  },
}
